import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { postData } from '../Services/api';
import { toast } from 'react-toastify';

const CouponAdd = () => {
  const [values, setValues] = useState({
    code: "",
    discountType: "percentage",
    discountValue: "",
    minOrderValue: "",
    maxDiscount: "",
    expiryDate: "",
    usageLimit: "",
  })
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const validateCoupon = () => {
    if (!values.code.trim()) {
      toast.error("Coupon code is required");
      return false;
    }
    if (!values.discountValue) {
      toast.error("Discount value is required");
      return false;
    }
    if (!values.expiryDate) {
      toast.error("Expiry date is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateCoupon()) return;
    setLoading(true)
    try {
      const res = await postData('/coupons/create', values);
      if (res.status) {
        toast.success(res.message)
        navigate('/coupons/coupon-list');
        setValues({
          title: "",
          content: "",
        })
      }
    } catch (error) {
      console.log("error coupon adding", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/coupons/coupon-list">Coupon</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Add Coupon
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Add Coupon</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>Add Coupon</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">

                      <div className="col-md-6">
                        <label>Coupon Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="code"
                          value={values.code}
                          onChange={handleChange}
                          placeholder="SAVE20"
                        />
                      </div>

                      <div className="col-md-6">
                        <label>Discount Type</label>
                        <select
                          className="form-control"
                          name="discountType"
                          value={values.discountType}
                          onChange={handleChange}
                        >
                          <option value="percentage">Percentage</option>
                          <option value="flat">Flat</option>
                        </select>
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Discount Value</label>
                        <input
                          type="number"
                          className="form-control"
                          name="discountValue"
                          value={values.discountValue}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Minimum Order Value</label>
                        <input
                          type="number"
                          className="form-control"
                          name="minOrderValue"
                          value={values.minOrderValue}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Max Discount</label>
                        <input
                          type="number"
                          className="form-control"
                          name="maxDiscount"
                          value={values.maxDiscount}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Expiry Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="expiryDate"
                          value={values.expiryDate}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mt-3">
                        <label>Usage Limit</label>
                        <input
                          type="number"
                          className="form-control"
                          name="usageLimit"
                          value={values.usageLimit}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-12 text-end mt-4">
                        <Link
                          to="/coupons/coupon-list"
                          className="btn btn-outline-secondary me-2"
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CouponAdd